import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordionStyle: {
      background:
        theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.background.paper,
      padding: '0px 20px',

      '&.MuiAccordion-root': {
        '&:before': {
          backgroundColor: 'unset',
        },
      },
      '&.MuiAccordion-root.Mui-expanded': {
        margin: 0,
      },
      '&.MuiPaper-elevation1': {
        boxShadow: 'unset',
      },
      '& .MuiAccordionSummary-content': {
        justifyContent: 'space-between',
      },
      '& .MuiAccordionSummary-expandIcon': {
        marginLeft: '-10px',
      },
      '& .MuiAccordionSummary-root': {
        padding: 0,
        flexDirection: 'row-reverse',
      },
      '& .MuiAccordionSummary-expandIcon.Mui-expanded': {
        transform: ' rotate(90deg) ',
      },
    },
    divider: {
      margin: '0px 20px',
      backgroundColor: theme.palette.grey[100],
      height: '1px',
    },
    dividerBlock: {
      background: theme.palette.grey[50],
    },
    arrow: {
      transform: ' rotate(180deg) ',
    },
    avatar: {
      marginRight: '16px',
      marginLeft: '36px',
    },
    name: {
      fontWeight: 700,
      fontSize: '15px',
      lineHeight: '21px',
      color: theme.palette.text.primary,
    },
    status: {
      fontWeight: 300,
      fontSize: '13px',
      lineHeight: '18px',
      color: '#60D8A9',
    },
    disactiveStatus: {
      color: theme.palette.error.main,
    },
    userInfoRow: {
      display: 'flex',
      marginBottom: '7px',
    },
    infoText: {
      fontWeight: 300,
      fontSize: '13px',
      lineHeight: '18px',
      color: theme.palette.text.primary,
    },
    infoTitle: {
      minWidth: '60px',
      marginRight: '8px',
      fontWeight: 700,
      fontSize: '13px',
      lineHeight: '18px',
      color: theme.palette.text.primary,
    },
    editIcon: {
      '&.MuiIconButton-root': {
        padding: 0,
      },
    },
    userBlock: {
      display: 'flex',
    },
    actionButtons: {
      display: 'flex',
      justifyContent: 'center',
      width: '48px',
      marginRight: '12px',
    },
  }),
);

export default useStyles;
